import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-safe-text-renderer',
    templateUrl: './safe-text-renderer.component.html',
    standalone: true,
    imports: [TranslateModule]
})
export class SafeTextRendererComponent implements ICellRendererAngularComp {

    public text: string;
    params: ICellRendererParams;
    constructor(private sanitizer: DomSanitizer, private translate: TranslateService) { }

    onUserAction() {
        this.params.node.setData(this.params.data);
        this.params.eGridCell.click();
      }

    initilize(params: ICellRendererParams) {
        this.params = params;
        this.text = params.getValue();
        this.text = '<div class="safe-text-renderer"><span class="top-text">' + this.translate.instant("fc_odo_msg4") + '</span><span class="bottom-text">' + 5 + '</span></div>';
    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

    sanitizerHtml(element) {
        let safeText = this.sanitizer.bypassSecurityTrustHtml(element);
        return safeText;
    }

}
